import { useQuery } from "@tanstack/react-query";
import { getPromoCampaign, type PromoCampaignPublic } from "../endpoints/public/promo-campaign_GET.schema";

export function usePromoCampaign() {
  const query = useQuery({
    queryKey: ["public", "promo-campaign"],
    queryFn: () => getPromoCampaign(),
    staleTime: 1000 * 60, // 60 s : aligné sur le Cache-Control backend
  });
  return { campaign: query.data?.campaign ?? null, isLoading: query.isLoading };
}

export type { PromoCampaignPublic };
